import _ from 'lodash';
import { handleApiResponse } from '../../fetchUtils';
import { EmeraldHost } from '../../config';

const asyncValidate = (values, dispatch, props, field)=> {
  const previousErrors = props.asyncErrors || {};
  const previousErrorCount = countErrors(previousErrors)

  return new Promise((resolve, reject) => {
    if(field === 'student[registration_code]') {
      (async function() {
        const resp = await fetch('/sections/registration_codes', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ registration_code: values.student.registration_code })
        });
        const data = await resp.json();
        if (data.valid_code && previousErrorCount === 0) {
          resolve()
        } else if (data.valid_code) {
          reject(previousErrors);
        } else {
          const newErrors = { student: Object.assign({}, previousErrors.student, { registration_code: 'is not valid' }) }
          reject(newErrors);
        }
      }());
    } else if(field === 'student[profile_attributes][username]') {
      (async function() {
        const resp = await fetch(`${EmeraldHost()}api/usernames/availability.json`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username: values.student.profile_attributes.username })
        });
        const data = await resp.json();
        if (data.available && previousErrorCount === 0) {
          resolve()
        } else if (data.available) {
          reject(previousErrors);
        } else {
          const newErrors = { student: Object.assign({}, previousErrors.student, { profile_attributes: { username: 'is already taken' } }) }
          reject(newErrors);
        }
      }());
    }
  })
}

const countErrors = errors => {
  if(_.isEmpty(errors)) {
    return 0
  } else {
    const usernameError = (errors.student.profile_attributes || {}).username ? 1 : 0
    const codeError = errors.student.registration_code ? 1 : 0

    return usernameError + codeError
  }
}

export default asyncValidate;
